module.exports = __webpack_public_path__ + "cbeeb2a8ac80a12807e48de114045186.png";